import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  darkGrey,
  listReset,
  printHidden,
  sizeMobile,
  sizeTablet,
  sizeTabletLg,
  standardBorder,
  standardPaddingMd,
  standardPaddingMobileMd,
  typeNavigationPage,
} from '~/styles';

export const FooterContainer = styled.footer<{ hideFooterMobile?: string }>`
  background-color: ${darkGrey};
  border-top: ${standardBorder};
  padding: ${standardPaddingMd} 0;
  ${sizeTablet(css`
    padding: 30px ${standardPaddingMobileMd} 40px;
  `)};
  ${props =>
    props.hideFooterMobile === 'hideFooterMobile'
      ? css`
          ${sizeTabletLg(css`
            display: none;
          `)};
        `
      : ''};
  ${printHidden};
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 48px;
  flex-direction: row;
  justify-content: space-between;
  ${sizeTabletLg(css`
    justify-content: flex-start;
  `)}
  ${sizeTablet(css`
    flex-direction: column;
  `)}
  ${sizeMobile(css`
    margin-top: auto;
  `)}
`;

export const RowList = styled.ul`
  ${listReset};
  padding: 16px 0;
  ${sizeMobile(css`
    padding: 0px;
  `)}
  margin: 16px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
`;

export const CopyRight = styled.p`
  ${typeNavigationPage};
  font-weight: 200;
  letter-spacing: 0.25px;
  line-height: 32px;
  margin-top: 4px;
  color: white;
  text-align: left;
  ${sizeTablet(css`
    text-align: center;
  `)};
`;
